<template>
  <div class="main-menu black"  v-b-hover="handleMoreNav" id="headMenu" :class="[isHovered ? 'main-menu-hover' : '']">
  	<div class="container menu-content">
  		<div class="row">
  		<div class="col-xs-1 logo">
  			<a href="/">VIA WATCH</a>
  		</div>

  		<ul class="col-xs-8 menu">
  			<li><a href="#" class="menu-item">Watches</a>
  				<ul class="subnav" v-show="isHovered">
  				  <li><router-link :to="{path: 'watchlist',query:{goodsType: 'bestSale'}}">Best Sale</router-link></li>
  				  <li><router-link :to="{path: 'watchlist',query:{goodsType: 'newArrival'}}">New Arrival</router-link></li>
  				  <li><a href="#">Brands</a></li>
  				</ul>
  			</li>
  			<li><a href="#" class="menu-item">Auction</a>
  				<ul class="subnav" v-show="isHovered">
  				  <li><a href="#">Open Lots</a></li>
  				  <li><a href="#">Live Auction</a></li>
  				</ul>
  			</li>
  			<li><a href="#" class="menu-item">Service</a>
  				<ul class="subnav" v-show="isHovered">
  				  <li><a href="#">Maintenance</a></li>
  				  <li><a href="#/sell">Sell a Watch</a></li>
  				  <li><a href="#">Trade a Watch</a></li>
  				</ul>
  			</li>
  			<li><a href="#" class="menu-item">Article</a>
  				<ul class="subnav" v-show="isHovered">
  				  <li><a href="#">Open Lots</a></li>
  				  <li><a href="#">Live Auction</a></li>
  				</ul>
  			</li>
  			<li><a href="#" class="menu-item">FAQ</a></li>
  		</ul>
      <!-- :class="[isHovered ? 'bg-white' : '']" -->
  	<!-- 	<div class="col-xs-3">
        <div class="search">
          <i class="icons"></i>
          <input type="text" placeholder="Search" class="Ainput" @focus="handleSearchFocus" @blur="handleSearchBlur">
        </div>
      </div> -->
  		</div>
  	</div>
  	<div class="clearfix"></div>
  	<div class="menu-prd" v-show="isHovered">
  		<ol class="container">
  			<li class="menu-prd-item" v-for="(item,index) in hotGoodsList" :key="index">
  				<a @click="goodsDetail(item.goodsId)"><div class="menu-prd-img">
  			  <img :src="item.picUrl" alt=""></div>
  					<b class="prd-brand">{{item.brandName}}</b>
  					<p class="prd-name">{{item.goodsName}}</p>
  					<span class="prd-price" v-if="item.webPrice">{{item.webPrice}}</span>
  			    <span class="prd-price" else>{{item.originalPrice}}</span>
  				</a>
  			</li>
  		</ol>
  		<div class="clearfix"></div>
  	</div>
  	<div class="search-box" v-show="searchFocus">
  		<div class="container">
  			<ul class="row">
  				<li class="col-md-3"></li>
  				<li class="col-md-4 ps">
  				  <ol class="dd">
  						<h3>POPULAR SEARCHES</h3>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  					</ol>
  				</li>
  				<li class="col-md-5 rs">
  					<ol class="dd">
  						<h3>RECENT SEARCHES</h3>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<li><a href="#'">asdfas</a></li>
  						<span class="clear-btn"><a href="#"> CLEAR</a></span>
  					</ol>
  				</li>
  			</ul>
  		</div>
  	</div>

  </div>
</template>

<script>
import {selectListByType} from '@/api/watchList'
export default {
  name: 'WhiteMenu',
  data() {
    return {
    	isHovered: false,
    	searchFocus: false,
      hotGoodsList: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init(){
      //初始化数据
      selectListByType({goodsType:'hot',isShow: 1}).then(response=>{
        this.hotGoodsList=response.data.data.list
      })
    },
    handleMoreNav(hovered) {
      if (hovered) {
      	this.isHovered = hovered
      } else if (!this.searchFocus) {
      	this.isHovered = hovered
      }
    },
    handleSearchFocus() {
    	this.searchFocus = true;
    },
    goodsDetail(goodsId){
     this.$router.push({ path: 'watchpage', query: { id: goodsId }}, () => {})
    },
    handleSearchBlur() {
    	// this.searchFocus = false;
    },
    handleCloeNav() {
    	var sp = document.getElementById("headNav")
    	if (!sp.contains(event.target)) {
    		this.searchFocus = false;
    		this.isHovered = false;
    	}

    }
  }
}
</script>

<style scoped>
  .col-lg-1, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9,
  .col-md-1, .col-md-10, .col-md-11, .col-md-12, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9,
  .col-sm-1, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9,
  .col-xs-1, .col-xs-10, .col-xs-11, .col-xs-12, .col-xs-2, .col-xs-3, .col-xs-4, .col-xs-5, .col-xs-6, .col-xs-7, .col-xs-8, .col-xs-9 {
      position: relative;
      min-height: 1px;
      padding-right: 15px;
      padding-left: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/WhiteMenu.vue